// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-attendance.page.title': 'Attendances',
    'team-member-attendance.page.archive.title': 'Archived Attendances',
    'team-member-attendance.page.search_results': 'Search Results',
    'team-member-attendance.page.create.title': 'Create New Attendance',
    'team-member-attendance.page.search.title': 'Find Attendances',
    'team-member-attendance.page.edit.title': 'Edit Attendance',
    'team-member-attendance.page.view.title': 'Attendance',
    'team-member-attendance.page.all': 'All',

    'team-member-attendance.button.cancel': 'Cancel',
    'team-member-attendance.button.select': 'Select',
    'team-member-attendance.button.find': 'Find Attendances',
    'team-member-attendance.button.search': 'Apply',
    'team-member-attendance.button.create': 'Save Attendance',
    'team-member-attendance.button.new': 'New Attendance',
    'team-member-attendance.button.save': 'Save Changes',
    'team-member-attendance.button.archive': 'Archive',
    'team-member-attendance.button.delete': 'Permanently Delete',
    'team-member-attendance.button.edit': 'Edit',
    'team-member-attendance.button.restore': 'Restore',
    'team-member-attendance.button.reset': 'Reset',
    'team-member-attendance.button.approve': 'Approve',

    'team-member-attendance.placeholder.search': 'Search attendances',

    'team-member-attendance.link.create_first_team_member_attendance': 'Click here to create your first attendance',
    'team-member-attendance.link.team_member_attendances': ' Return to Attendances',
    'team-member-attendance.link.archive': 'Archived Attendances',
    'team-member-attendance.link.retry': 'Click here to retry',

    'team-member-attendance.checkbox.all': 'Check All',
    'team-member-attendance.checkbox.actions_label': 'with selected',

    'team-member-attendance.label.team_member_name': 'Team Member',

    'team-member-attendance.label.from__absent_on': 'From absent on',
    'team-member-attendance.label.to__absent_on': 'To absent on',
    'team-member-attendance.label.absent_on': 'Absent On',

    'team-member-attendance.label.organization_leave_type_name': 'Organization Leave Type',

    'team-member-attendance.label.memo': 'Memo',

    'team-member-attendance.label.is_paid_leave': 'Is Paid Leave',

    'team-member-attendance.label.organization_leave_duration_type_name': 'Organization Leave Duration Type',

    'team-member-attendance.label.from__duration_in_minutes': 'From duration in minutes',
    'team-member-attendance.label.to__duration_in_minutes': 'To duration in minutes',
    'team-member-attendance.label.duration_in_minutes': 'Duration In Minutes',
    'team-member-attendance.label.duration': 'Duration',

    'team-member-attendance.label.from__approved_on': 'From approved on',
    'team-member-attendance.label.to__approved_on': 'To approved on',
    'team-member-attendance.label.approved_on': 'Approved On',

    'team-member-attendance.label.approved_by_user_name': 'Approved By User',

    'team-member-attendance.label.from__created_at': 'From created at',
    'team-member-attendance.label.to__created_at': 'To created at',
    'team-member-attendance.label.created_at': 'Created At',

    'team-member-attendance.label.from__updated_at': 'From updated at',
    'team-member-attendance.label.to__updated_at': 'To updated at',
    'team-member-attendance.label.updated_at': 'Updated At',

    'team-member-attendance.label.from__deleted_at': 'From deleted at',
    'team-member-attendance.label.to__deleted_at': 'To deleted at',
    'team-member-attendance.label.deleted_at': 'Deleted At',

    'team-member-attendance.label.status': 'Status',

    'team-member-attendance.sort.field_label': 'Field',
    'team-member-attendance.sort.direction_label': 'Direction',
    'team-member-attendance.sort.direction_ascending': 'Ascending',
    'team-member-attendance.sort.direction_descending': 'Descending',

    'team-member-attendance.modal.title.team_member_attendance_archive': 'Archive Attendance',
    'team-member-attendance.modal.title.team_member_attendance_approve': 'Approve Attendance',
    'team-member-attendance.modal.title.team_member_attendance_delete_permanently': 'Delete Attendance',
    'team-member-attendance.modal.title.team_member_attendance_restore': 'Restore Attendance',

    'team-member-attendance.modal.message.team_member_attendance_archive': 'Are you sure that you want to move this attendance to the archive? | Are you sure that you want to move these attendances to the archive?',
    'team-member-attendance.modal.message.team_member_attendance_approve': 'Are you sure that you want to approve this attendance? | Are you sure that you want to approve these attendances?',
    'team-member-attendance.modal.message.team_member_attendance_delete_permanently':
        'Are you sure that you want to permanently delete this attendance? This action cannot be undone. | Are you sure that you want to permanently delete these attendances? This action cannot be undone.',
    'team-member-attendance.modal.message.team_member_attendance_restore': 'Are you sure that you want to restore this attendance? | Are you sure that you want to restore these attendances?',

    'team-member-attendance.success.message.team_member_attendance_created': 'Your attendance has been created',
    'team-member-attendance.success.message.team_member_attendance_updated': 'Your attendance has been updated',
    'team-member-attendance.success.message.team_member_attendance_restored': 'Your attendance has been restored | All selected attendances were restored',
    'team-member-attendance.success.message.team_member_attendance_deleted': 'Your attendance has been permanently deleted | All selected attendances were permanently deleted',
    'team-member-attendance.success.message.archived_team_member_attendances': 'Your attendance was moved to the archive | All selected attendances were moved to the archive',
    'team-member-attendance.success.message.approved_team_member_attendances': 'Your attendance was approved | All selected attendances were approved',

    'team-member-attendance.error.message.archived_team_member_attendances': 'This attendance was already moved to the archive | These attendances were already moved to the archive',
    'team-member-attendance.error.message.approved_team_member_attendances': 'This attendance was already approved | These attendances were already approved',
    'team-member-attendance.error.message.team_member_attendance_deleted': 'This attendance was already permanently deleted | These attendances were already permanently deleted',
    'team-member-attendance.error.message.team_member_attendance_restored': 'This attendance was already restored | These attendances were already restored',
    'team-member-attendance.error.message.error_loading_page': 'Sorry, there was an error loading attendance.| Sorry, there was an error loading attendances.',

    'team-member-attendance.message.search.no_archived_team_member_attendances': "You haven't archived any team any member any attendances as yet.",
};
